export const U3141LotStateEnum = [
  {
    value: "validate",
    label: {
      fr: "Validé",
      en: "Validated",
    },
  },
  {
    value: "notValidate",
    label: {
      fr: "Non Validé",
      en: "Not Validated",
    },
  },
];
